import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useReducer,
} from 'react'

import { CookieName } from 'app/shared/enums'
import { DEFAULT_LANGUAGE } from 'app/shared/constants'

import { Dispatch, Props, State } from './types'
import reducer from './reducer'

const initialState =
  localStorage.getItem(CookieName.Language) || DEFAULT_LANGUAGE
const initialValue: Props = {
  dispatchs: {
    set: () => null,
  },
  provided: false,
  state: initialState,
}

export const LanguageContext = createContext<Props>(initialValue)

export const LanguageProvider: React.FunctionComponent = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const set = useCallback((language: string) => {
    localStorage.setItem(CookieName.Language, language)

    dispatch({
      type: 'SET_LANGUAGE',
      payload: language,
    })
  }, [])

  const dispatchs = useMemo(
    () => ({
      set,
    }),
    [set]
  )

  return (
    <LanguageContext.Provider
      value={{
        dispatchs,
        provided: true,
        state,
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = (): [Dispatch, State] => {
  const { state, provided, dispatchs } = useContext(LanguageContext)

  if (!provided) {
    throw new Error('usePopup must be used within a PopupProvider.')
  }

  return [dispatchs, state]
}
